// extracted by mini-css-extract-plugin
export default {"scrollToTopButton":"ScrollToTopButton_scrollToTopButton__jTrpf","scrolled":"ScrollToTopButton_scrolled__HlmeT"};